import EhblManifestApiUrls from 'src/apiUrls/EhblManifestApiUrls'
import FormProperties from './FormProperties'
import { Box, Card, useTheme } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import { components, useServices, useTranslation } from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import ManifestEditPage from './ManifestEditPage'
import Stepper from '../../../components/aciacehighway/Stepper'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'
import HouseBillAttachTable from '../manifest/housebill/HouseBillAttachTable'
import StatusNotificationListPage from './StatusNotificationListPage'
import ViewLogsHistory from './ViewLogsHistory'
import CloseMsgAttachTable from '../manifest/closemsg/CloseMsgAttachTable'
import Namespace from 'src/constants/locale/Namespace'
import EhblManifestKeys from 'src/constants/locale/key/EhblManifest'

const {
  form: { CngEditForm }
} = components

function EditPage({ history, loading, location, onSetLoading, showNotification }) {
  const { id } = useParams()

  const { state } = location
  const manifestData = useRef(state?.manifestData || null)
  const [step, setStep] = useState((state?.step ? state.step : 1) - 1)
  const [manifestStatus, setManifestStatus] = useState(null)
  const [stepIconColor, setStepIconColor] = useState({})
  const [completed, setCompleted] = useState({})
  const theme = useTheme()
  const [refresh, setRefresh] = useState(null)

  const { securedSendRequest } = useServices()
  const [subLocationConfirmDialog,setSubLocationConfirmDialog]  = useState({open: false, manifest: {}, step : null})

  const { translate } = useTranslation(Namespace.EHBL_MANIFEST)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
      let updateCngSuccessMsg = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.UPDATE_CNG_SUCCESS_MSG
      )

      let updateSubLocationSuccessMsg = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.UPDATE_SUB_LOCATION_SUCCESS_MSG
      )

      let updateFailedMsg = translate(
        Namespace.EHBL_MANIFEST,
        EhblManifestKeys.UPDATE_FAILED_MSG
      )

     return {
        updateCngSuccessMsg,
        updateSubLocationSuccessMsg,
        updateFailedMsg
     }
  }    

  function handleUpdate(data, step){
    setSubLocationConfirmDialog({open : false, manifest : {}, step : null})
    onSetLoading(true)
    securedSendRequest.execute(
        'PUT',
        EhblManifestApiUrls.PUT,
        data,
        (response) => {
          if (response.status === 200) {
            if (response.data) {
              const errorMessages = response.data.errorMessages

              if (!errorMessages) {

                if(data.updateHouseBillSubLocationFlag && data.updateHouseBillSubLocationFlag == "true"){
                  showNotification(
                    'success',
                    translatedTextsObject.updateSubLocationSuccessMsg
                  )
                }else {
                  showNotification(
                    'success',
                    translatedTextsObject.updateCngSuccessMsg
                  )
                }

                manifestData.current = response.data
                setRefresh(Math.random())

                if(step){
                  setStep(step)
                }
              } else {
                errorMessages.forEach((message) =>
                  showNotification('error', message)
                )
              }
            }
          }
          onSetLoading(false)
        },
        (error) => {
          const { data } = error.response

          if (data && data.errorMessages) {
            showNotification('error', data.errorMessages)
          }
          onSetLoading(false)
        }
      )
  }

  function renderContent(step) {
    switch (step) {
      case 0:
        return (
          <ManifestEditPage
            key={refresh}
            id={id}
            manifestData={manifestData}
            onChangeStep={(step) => setStep(step)}
            onSetLoading={onSetLoading}
            onSetManifestStatus={(status) => setManifestStatus(status)}
            showNotification={showNotification}
            step={step}
            handleUpdate={handleUpdate}
            subLocationConfirmDialog={subLocationConfirmDialog}
            setSubLocationConfirmDialog={setSubLocationConfirmDialog}
          />
        )
      case 1:
        return (
          <HouseBillAttachTable
            history={history}
            showNotification={showNotification}
            manifestId={id}
            onChangeStep={(step) => setStep(step)}
            step={step}
            loading={loading}
            onSetLoading={onSetLoading}
            manifestData={manifestData}
          />
        )
      case 2:
        return (
          <StatusNotificationListPage
          history={history}
          showNotification={showNotification}
          manifestId={id}
          manifestData={manifestData}
          onSetLoading={onSetLoading}
          onChangeStep={(step) => setStep(step)}
          step={step}
        />
        )  
      case 3:
        return (
          <CloseMsgAttachTable
          history={history}
          showNotification={showNotification}
          manifestId={id}
          onChangeStep={(step) => setStep(step)}
          step={step}
          loading={loading}
          onSetLoading={onSetLoading}
          manifestData={manifestData}
        />
        )
      case 4:
        return (
          <ViewLogsHistory
            manifestId={id}
            history={history}
            onChangeStep={(step) => setStep(step)}
            step={step}
          />
        )
    }
  }

  return (
    <>
    <Card>
      <Stepper
          steps={!manifestStatus || manifestStatus === 'DR' ? ['Create manifest', 'Add house bills', 'Set status notification', 'Add Close Message'] : ['Create manifest', 'Add house bills', 'Set status notification','Add Close Message', 'View logs & history']}
        activeStep={step}
        completed={completed}
        onSetActiveStep={(step) => setStep(step)}
        stepIconColor={stepIconColor}
      />
        <Box padding={2}>
        {renderContent(step)}
      </Box>
    </Card>
    </>
  )

}

export default withFormState(EditPage)
